import React from "react";

import PortalLayout from "../home/portalLayout.cmpt";
import RegistroSeguridad from "./contenedor.cmpt";

export default class RegistroSeguridadPortal extends React.Component {
	componentWillMount() {
		localStorage.setItem("hashThree", this.props.hashThree);
	}

	render() {
		return <PortalLayout modulo={RegistroSeguridad} redux={this.props.redux} hashOne={this.props.hashOne} hashTwo={this.props.hashTwo} hashThree={this.props.hashThree} />;
	}
}


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/portal.cmpt.js